import {  IsNotEmpty, IsAlphanumeric, IsOptional, IsNumber } from 'class-validator';
import { ApiProperty } from '@nestjs/swagger';

export class CategoryItemRequest {
    @ApiProperty()
    @IsNotEmpty()
    @IsAlphanumeric()
    categoryId: number;

    @ApiProperty()
    @IsNotEmpty()
    @IsAlphanumeric()
    itemSubCategoryId: number;

    @ApiProperty()
    @IsNotEmpty()
    @IsAlphanumeric()
    itemId?: number;
}